// DS: i3.13
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const GoToPage: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        id="Icon"
        fillRule="evenodd"
        d="M14.75 3.25a1 1 0 1 0 0 2h2.586l-7.793 7.793a1 1 0 1 0 1.414 1.414l7.793-7.793V9.25a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1zm-11.5 3.5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2h-4v11h11v-4.5a1 1 0 1 1 2 0v5.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  </IconWrap>
);
GoToPage.displayName = 'GoToPage';

export default GoToPage;
